import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "secondSublabel"];

  inputSelector = "";
  secondInputSelector = "";
  selectedIds = [];
  secondSelectedIds = [];
  secondSelectedClass = "Button--secondary";
  hasBeenInteractedWith = false;

  connect() {
    setTimeout(() => {
      this.inputSelector = this.data.get("inputSelector");
      this.secondInputSelector = this.data.get("secondInputSelector") || "";
      this.selectedIds = this.parseSelectedIds(this.data.get("selectedIds"));
      this.secondSelectedIds = this.parseSelectedIds(
        this.data.get("secondSelectedIds")
      );
      this.secondSelectedClass =
        this.data.get("secondSelectedClass") || this.secondSelectedClass;
      this.redraw();
    }, 0);
  }

  toggle(event) {
    const button = event.currentTarget;
    const optionId = JSON.parse(button.dataset.optionId);
    const optionKey = this.optionKey(optionId);

    if (this.isSelected(this.selectedIds, optionKey)) {
      this.selectedIds = this.removeSelectedId(this.selectedIds, optionKey);
      if (this.hasSecondSelectionInput()) {
        this.secondSelectedIds = this.addSelectedId(
          this.secondSelectedIds,
          optionId,
          optionKey
        );
      }
    } else if (
      this.hasSecondSelectionInput() &&
      this.isSelected(this.secondSelectedIds, optionKey)
    ) {
      this.secondSelectedIds = this.removeSelectedId(
        this.secondSelectedIds,
        optionKey
      );
    } else {
      this.selectedIds = this.addSelectedId(this.selectedIds, optionId, optionKey);
      this.secondSelectedIds = this.removeSelectedId(
        this.secondSelectedIds,
        optionKey
      );
    }

    this.hasBeenInteractedWith = true;
    this.redraw();
  }

  redraw() {
    const selectedIdKeys = this.selectedIdKeys(this.selectedIds);
    const secondSelectedIdKeys = this.selectedIdKeys(this.secondSelectedIds);

    // Go through all the buttons
    this.buttonTargets.forEach((button) => {
      const buttonIdKey = button.dataset.optionId;
      const selectedInFirstInput = selectedIdKeys.has(buttonIdKey);
      const selectedInSecondInput = secondSelectedIdKeys.has(buttonIdKey);

      button.classList.remove(this.secondSelectedClass);

      if (selectedInFirstInput) {
        button.classList.remove("Button--alwaysoutline");
      } else if (selectedInSecondInput) {
        button.classList.remove("Button--alwaysoutline");
        button.classList.add(this.secondSelectedClass);
      } else {
        button.classList.add("Button--alwaysoutline");
      }

      const secondSublabel = button.querySelector(
        "[data-multi-select-pills-target~='secondSublabel']"
      );
      if (secondSublabel) {
        secondSublabel.classList.toggle("u-hidden", !selectedInSecondInput);
      }
    });

    const changedInputs = [
      this.writeSelectionInput(this.inputSelector, this.selectedIds),
      this.writeSelectionInput(this.secondInputSelector, this.secondSelectedIds),
    ].filter(Boolean);

    if (this.hasBeenInteractedWith) {
      changedInputs.forEach((input) => {
        input.dispatchEvent(
          new CustomEvent("change", {
            bubbles: true,
            detail: { valueChanged: true },
          })
        );
      });
    }
  }

  parseSelectedIds(value) {
    if (!value) {
      return [];
    }

    return JSON.parse(value);
  }

  hasSecondSelectionInput() {
    return this.secondInputSelector.length > 0;
  }

  optionKey(optionId) {
    return JSON.stringify(optionId);
  }

  selectedIdKeys(selectedIds) {
    return new Set(selectedIds.map((id) => this.optionKey(id)));
  }

  isSelected(selectedIds, optionKey) {
    return this.selectedIdKeys(selectedIds).has(optionKey);
  }

  addSelectedId(selectedIds, optionId, optionKey = this.optionKey(optionId)) {
    if (this.isSelected(selectedIds, optionKey)) {
      return selectedIds;
    }

    return selectedIds.concat([optionId]);
  }

  removeSelectedId(selectedIds, optionKey) {
    return selectedIds.filter((id) => this.optionKey(id) !== optionKey);
  }

  writeSelectionInput(inputSelector, selectedIds) {
    if (!inputSelector) {
      return;
    }

    const input = document.querySelector(inputSelector);
    if (!input) {
      return;
    }

    const nextValue = JSON.stringify(selectedIds);
    const valueChanged = input.value !== nextValue;
    input.value = nextValue;

    return valueChanged ? input : null;
  }
}
